module.exports = __webpack_public_path__ + "img/icon-danger.6829dd56.svg";